import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import './assets/public.css'
import './plugins/element.js'
import './assets/font.css'
import './assets/api.js'

import axios from 'axios'
Vue.prototype.$axios = axios    //全局注册，使用方法为:this.$axios 
import Qs from 'qs'
Vue.prototype.qs = Qs    //全局注册，使用方法为:this.$axios 

// Vue.prototype.ip = 'http://127.0.0.1:80'
Vue.prototype.ip = 'https://www.yuchengprotect.com'

// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'

import 'swiper/swiper-bundle.css';


Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  created(){
    this.$i18n.locale = 'en'
  },
  mounted () {
    document.dispatchEvent(new Event('render-event'))
    // document.dispatchEvent(new Event('custom-render-trigger'))
  },
  render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {    
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})